import { IhmLearningAndDevelopmentServiceClientConfigFactory } from '@amzn/coral-config_ihm-learning-and-development-service'
import { CompleteTrainingEventRequest, GetAnnouncementsRequest, IhmLearningAndDevelopmentService } from '@amzn/coral_com-amazon-ihmlearninganddevelopmentservice'
import { createTypeScriptClient } from '@amzn/ihm-associate-tools-js-lib'
import sentryFetch from '@amzn/sentry-fetch'

export class IhmLearningAndDevelopmentServiceClient {
    private static client: IhmLearningAndDevelopmentService
    private static _instance: IhmLearningAndDevelopmentServiceClient

    public static getInstance (): IhmLearningAndDevelopmentServiceClient {
        if (!IhmLearningAndDevelopmentServiceClient._instance) {
            IhmLearningAndDevelopmentServiceClient._instance = new IhmLearningAndDevelopmentServiceClient()
            console.log('L&D service client is initialized')
        }
        return IhmLearningAndDevelopmentServiceClient._instance
    }

    public getAnnouncements = async (storeId: string, locale: string = 'en-US') => {
        const request = GetAnnouncementsRequest.clone({
            storeId,
            locale,
        })
        return IhmLearningAndDevelopmentServiceClient.client.getAnnouncements(request).toPromise()
    }

    public completeTrainingEvent = async (
        storeId: string,
        eventId: string,
        startTime: number,
        endTime: number,
    ) => {
        const request = CompleteTrainingEventRequest.clone({
            storeId,
            eventId,
            dwellTime: endTime - startTime,
        })
        return IhmLearningAndDevelopmentServiceClient.client.completeTrainingEvent(request).toPromise()
    }

    private constructor () {
        IhmLearningAndDevelopmentServiceClient.client = createTypeScriptClient({
            configFactory: IhmLearningAndDevelopmentServiceClientConfigFactory,
            clientConstructor: IhmLearningAndDevelopmentService,
            sentryFetch,
        })
    }
}

export default IhmLearningAndDevelopmentServiceClient
